import { ICard } from "../models/ICard"
import { ILocation } from "../models/ILocation"
import { Endpoints } from "../utilities/endpoints";
import { isSubmitting } from "./loadActions";
import ApiClient from "../utilities/http";


//TODO add token cookie
export async function submitOrder(location: ILocation, cards: ICard[]) {
    let cardData = cards.map(({ id, countedInventory }) => ({ id: id, to_order: countedInventory }));
    return new Promise(async (resolve, reject) => {
        if (cards.length === 0) {
            reject('no cards, not submitting');
        }
        ApiClient.post(Endpoints.PLACE_ORDER,
            { location: location.id, cards: cardData })
            .then(res => { resolve(res) })
            .catch(err => { reject(err) });
    });
}